module.exports = __webpack_public_path__ + "static/img/BUBLY_SMILE-COCOPINE.a0f3723.a0f3723.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/BUBLY_SMILE-COCOPINE.a0f3723.gif
// module id = ZHKF
// module chunks = 0